'use client';

import React from 'react';
import Image from 'next/image';
import {Avatar} from '@udemy-v2/react-core-components';
import classNames from 'classnames';

import styles from './community-powered-badge.module.scss';

export type CommunityPoweredBadgeSize = 'sm' | 'lg';

const ASSET_BASE = (process.env.ASSET_PREFIX ?? '').replace(/\/$/, '');
const COMMUNITY_POWERED_BADGE_LG = `${ASSET_BASE}/community-powered-en-us-v1.png`;
const COMMUNITY_POWERED_BADGE_SM = `${ASSET_BASE}/community-powered-sm-en-us-v1.png`;

export interface CommunityPoweredBadgeProps {
    imageUrl: string;
    displayName: string;
    size?: CommunityPoweredBadgeSize;
    className?: string;
    'data-purpose'?: string;
}

export function CommunityPoweredBadge({
    imageUrl,
    displayName,
    size = 'lg',
    className,
    'data-purpose': dataPurpose = 'instructor-image',
}: CommunityPoweredBadgeProps) {
    const badgeImage = size === 'sm' ? COMMUNITY_POWERED_BADGE_SM : COMMUNITY_POWERED_BADGE_LG;

    return (
        <div
            className={classNames(
                styles['badge-container'],
                size === 'sm' ? styles['badge-container-sm'] : styles['badge-container-lg'],
                className,
            )}
            data-purpose={dataPurpose}
        >
            <Image
                className={styles['community-powered']}
                src={badgeImage}
                alt=""
                width={size === 'sm' ? 60 : 154}
                height={size === 'sm' ? 60 : 154}
                unoptimized
            />
            <Avatar
                className={classNames(
                    styles.avatar,
                    size === 'sm' ? styles['avatar-sm'] : styles['avatar-lg'],
                )}
                user={{
                    display_name: displayName,
                    image_200_H: imageUrl,
                }}
                srcKey="image_200_H"
                alt="NONE"
            />
        </div>
    );
}
